import { Controller } from 'stimulus'
import { getLogger } from '@blueberry/observability'

const logger = getLogger('balance/bpx-track')

const TRACK_URL = '/balance/track'

// Fires a Balance product event the server can't observe: a tab switch handled
// entirely in the DOM, or a click on a link that navigates away. The endpoint
// allowlists event names and properties, so nothing here is trusted.
//
//   <button data-controller="bpx-track"
//           data-action="click->bpx-track#fire"
//           data-bpx-track-event-value="balance_records_tab_viewed"
//           data-bpx-track-properties-value='{"tab": "vitals"}'>
export default class extends Controller {
  static values = {
    event: String,
    properties: Object,
  }

  declare eventValue: string
  declare hasEventValue: boolean
  declare propertiesValue: Record<string, unknown>

  fire() {
    if (!this.hasEventValue) {
      logger.error('Missing event value')
      return
    }

    try {
      void fetch(TRACK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': this.csrfToken(),
        },
        body: JSON.stringify({
          event_name: this.eventValue,
          properties: this.propertiesValue ?? {},
        }),
        // The outbound-link events fire as the page unloads.
        keepalive: true,
      }).catch((error) => logger.error('Error posting Balance event:', error))
    } catch (error) {
      logger.error('Error posting Balance event:', error)
    }
  }

  // Every BPX page renders this meta tag in layout.html; the tab bars and
  // outbound links this controller binds to are not inside a form.
  private csrfToken(): string {
    const meta = document.querySelector<HTMLMetaElement>(
      'meta[name="csrf-token"]',
    )
    return meta?.content ?? ''
  }
}
